import { Component, OnInit, Input, EventEmitter, Output, OnDestroy, OnChanges, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
//import { GridOptions, GridApi, AllModules } from '@ag-grid-enterprise/all-modules';
import { GridOptions, GridApi } from "ag-grid-community";
import { of as observableOf, Subscription, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IconActionRendererComponent } from "../../../../common/components/ag-grid/icon-action-renderer.component";

import { CasingConstructionRulesService } from "../services/casing-construction-rules.service";
import { DialogService } from "../../../../common/services/dialog.service";
import { DomainDefinitionService } from "../../../../builder/services/domain-definition.service";
import { GridFormatterService } from "../../../../common/services/grid-formatter.service";
import { CasingConditionModel,CasingPlanModel, CasingType, CasingTypeModel, DrillingEquipmentModel, FormationModel, SegmentWizardSteps, WellDirection, WellSegmentGisDataModel, WellSegmentModel } from "../models/casing-plan.model";
import { deepClone } from "../../../../builder/models/editor.model";
import { isDefined } from "../models/casing-plan-functions.model";
import { DriftThicknessAlert } from "../models/Alerts.model";
import { requireNonDefaultOption, reconditioned } from "../models/validators.model";

@Component({
    selector: "well-segment-wizard",
    templateUrl: "./well-segment-wizard.component.html",
    styleUrls: ["../new-casing-plan.component.scss"],
    providers: [DomainDefinitionService, DialogService],
    standalone: false
})
export class WellSegmentWizardComponent implements OnInit, OnChanges, OnDestroy {

    public _affirmComplete: boolean;
    public casingTypes = CasingType;
    public wellDirections = WellDirection;
    public addNewString: string;
    public allCasings: Subscription;
    public allFormations: Subscription;
    public allTools: Subscription;
    public availableCasings$: Observable<CasingTypeModel[]>;
    public availableCasings: CasingTypeModel[] = [];
    public availableConditions$: Observable<CasingConditionModel[]>;
    public availableConditions: CasingConditionModel[] = [];
    public availableFormations$: Observable<FormationModel[]>;
    public availableFormations: FormationModel[] = [];
    public availableTools$: Observable<DrillingEquipmentModel[]>;
    public availableTools: DrillingEquipmentModel[] = [];
    public canBeCompleted: boolean = false;
    public completionEligible: Subscription;
    public defaultCondition = { id: "-1", name: " ", conditions: [] } as CasingConditionModel;
    private disableForm: boolean = true;
    public editingWellSegment: WellSegmentModel;
    public formGroup: FormGroup;
    public gisGridOptions: GridOptions;
    public gisColumnDefs = [
    {
        headerName: "Point",
        field: "point",
        tooltipField: "point"
    },
    {
        headerName: "Measured Depth (ft)",
        field: "md"
    },
    {
        headerName: "Inclination (ï¿½)",
        headerTooltip: "Inclination (ï¿½)",
        field: "inclination",
        tooltipField: "inclination"
    },
    {
        headerName: "Azimuth (ï¿½)",
        headerTooltip: "Azimuth (ï¿½)",
        field: "azimuth",
        tooltipField: "azimuth"
    },
    {
        headerName: "True Vertical Depth (ft)",
        field: "tvd",
        tooltipField: "tvd"
    },
    {
        headerName: "Latitude",
        field: "latitude",
        tooltipField: "latitude"
    },
    {
        headerName: "Longitude",
        field: "longitude",
        tooltipField: "longitude"
    },
    {
        headerName: "",
        cellStyle: { 'text-align': "right", 'line-height': 1.75, 'min-width': "100px" },
        cellRenderer: IconActionRendererComponent,
        cellRendererParams: {
        buttons: [
            {
            action: (obj) => this.sortHigher(obj),
            icon: "up"
            },
            {
            action: (obj) => this.sortLower(obj),
            icon: "down"
            }, {

            action: (obj) => this.deleteRow(obj),
            icon: "delete"
            }
        ]
        }
    }
    ];
    public gisColumnDefsNoEdit = [
    {
        headerName: "Point",
        field: "point"
    },
    {
        headerName: "Measured Depth (ft)",
        field: "md",
        tooltipField: "md"
    },
    {
        headerName: "Inclination (&#176;)",
        field: "inclination",
        tooltipField: "inclincation"
    },
    {
        headerName: "Azimuth (&#176;)",
        field: "azimuth",
        tooltipField: "Azimuth"
    },
    {
        headerName: "True Vertical Depth (ft)",
        field: "tvd",
        tooltipField: "tvd"
    },
    {
        headerName: "VertSect (ft)",
        field: "vertSect",
        tooltipField: "vertSect"
    },
    {
        headerName: "Latitude",
        field: "latitude",
        tooltipField: "latitude"
    },
    {
        headerName: "Longitude",
        field: "longitude",
        tooltipField: "longitude"
    }
    ];
    public gisGridApi: GridApi;
    public isComplete: boolean = false;
    public newGisObject: WellSegmentGisDataModel;
    public obj: any;
    public pointOptionList = [
        { id: "Kick Point", text: "Kick Point" },
        { id: "Survey Station", text: "Survey Station " },
        { id: "End", text: "End" }
    ];
    public segmentColumnDefs = [
    {
        headerName: "Casing Type",
        field: "casingType"
    },
    {
        headerName: "Condition",
        field: "casingCondition"
    },
    {
        headerName: "Casing Diameter",
        field: "diameter"
    },
    {
        headerName: "Casing Length",
        field: "length"
    },
    {
        headerName: "Cement Volume",
        field: "cementVolume"
    }
    ];
    saveSubscription: Subscription = new Subscription();
    public segmentData = [];
    public segmentGridApi: GridApi;
    public segmentGridOptions: GridOptions;
    public selectedCondition: string;
    public selectedTool: string;
    public showCasingDefinition: boolean = true;
    public showReconditionedInfo: boolean = true;
    public showSegmentRules: boolean = true;
    public steps = SegmentWizardSteps;
    public validationsFailed: string[] = [];

    @Input() public activeEditing: boolean;
    @Input() set affirmComplete(value: boolean) {
        this._affirmComplete = value;
        if (value) {
          this.addNewString = "false";
        }
    }
    @Input() public applicationData: {
        applicationNumber: string,
        wellName: string,
        wellNumber: string
    };
    @Input() public saveInProgress: EventEmitter<boolean>;
    @Input() public currentCasingPlan: CasingPlanModel;
    @Input() public enableEditing: boolean;
    @Input() public isNewWell: boolean;
    @Input() public position: string;
    @Input() public previousSegment: WellSegmentModel;
    @Input() public queueSegment: boolean | undefined;
    @Input() public requireAngles: boolean;
    @Input() public rulesService: CasingConstructionRulesService;
    @Input() public segmentChanged: EventEmitter<WellSegmentModel>;
    @Input() public segmentIndex: number;
    @Input() public substep: SegmentWizardSteps;
    @Input() public wellDirection: string;
    @Input() public wellSegment: WellSegmentModel;

    @Output() public formReady = new EventEmitter<FormGroup>(null);
    @Output() public makeSegmentActive = new EventEmitter<WellSegmentModel>();
    @Output() public segmentAdded = new EventEmitter<boolean>();
    @Output() public segmentDeleted = new EventEmitter<number>();

    constructor(
        public readonly dialogService: DialogService,
        public readonly domainService: DomainDefinitionService,
		public readonly builder: FormBuilder,
		private readonly _formatter: GridFormatterService
	) { }

    ngOnChanges(changes: SimpleChanges) {
        let formBuilt: boolean = false;
        if (changes["activeEditing"]) {
            const value = changes["activeEditing"].currentValue;
            if (value) {
            this.buildForm();
            formBuilt = true;
            if (this.substep === SegmentWizardSteps.ReviewWellSegment) {
                this.parseSegmentData();
            }
            }
        }
        if (changes["substep"] && !formBuilt) {
            this.buildForm();
            if (changes["substep"].currentValue === SegmentWizardSteps.ReviewWellSegment) {
            if (!this._affirmComplete) {
                this.addNewString = (this.segmentIndex < this.currentCasingPlan.wellSegments.length - 1) ? "true" : "";
            }
            this.parseSegmentData();
            }
        }
    }

    ngOnDestroy() {
        if (this.allCasings) {
            this.allCasings.unsubscribe();
        }
        if (this.allFormations) {
            this.allFormations.unsubscribe();
        }
        if (this.allTools) {
            this.allTools.unsubscribe();
        }
        if (this.completionEligible) {
            this.completionEligible.unsubscribe();
        }
        if (this.saveSubscription) {
            this.saveSubscription.unsubscribe();
        }
    }

    ngOnInit() {
        this.newGisObject = new WellSegmentGisDataModel();
        this.newGisObject.point = "Kick Point";

        this.availableCasings$ = this.getAvailableCasings();
        this.allCasings = this.rulesService.availableCasings$.subscribe((data) => {
            this.availableCasings = data;
        });
        this.allFormations = this.rulesService.availableFormations$.subscribe((data) => {
            this.availableFormations = data;
        });
        this.allTools = this.rulesService.availableTools$.subscribe((data) => {
            this.availableTools = data;
        });
        this.completionEligible = this.rulesService.completionEligible$.subscribe((result) => {
            switch (result) {
            case "yes":
                this.canBeCompleted = true;
                this.isComplete = false;
                this.queueSegment = undefined;
                break;
            case "no":
                this.queueSegment = true;
                this.canBeCompleted = false;
                this.isComplete = false;
                break;
            case "required":
                this.queueSegment = false;
                this.canBeCompleted = true;
                this.isComplete = true;
                break;
            }
        });

        this.availableConditions$ = this.getAvailableConditions();
        this.availableTools$ = (this.wellSegment.casingType && this.wellSegment.casingType.definition) ? this.getAvailableTools() : observableOf([]);
        this.saveSubscription = this.saveInProgress.subscribe((disable) => {
            this.disableForm = disable;
            if (this.formGroup) {
                if (disable) {
                    this.formGroup.disable();
                } else {
                    this.formGroup.enable();
                }
            }
            if (this.activeEditing) {
                this.formReady.emit(this.formGroup);
            }
        });
    }

    get casingType(): string {
        let type = "";
        if (this.wellSegment.casingType) {
            if (this.wellSegment.casingType.definition) {
            if (this.wellSegment.casingCondition && this.wellSegment.casingCondition.name) {
                type = `${this.wellSegment.casingCondition.name} ${this.wellSegment.casingType.definition}`;
            } else {
                type = this.wellSegment.casingType.definition;
            }
            }
        }
        return type;
    }

    get gisObjectInvalid(): boolean {
        return (this.newGisObject.tvd === null ||
            typeof this.newGisObject.tvd === "undefined" ||
            this.newGisObject.tvd.toString() === "" ||
            this.newGisObject.tvd < 0) ||
            (this.newGisObject.point === "" ||
            this.newGisObject.point === null ||
            typeof this.newGisObject.point === "undefined");
    }

    get glacialDrift(): number {
        const alert = this.rulesService.observableAlerts.find(a => a instanceof DriftThicknessAlert);
        if (alert && alert.applicable) {
            const thicknessAlert = <DriftThicknessAlert>alert;
            return thicknessAlert.thickness;
        }
        return 0;
    }

    get hasConductorString(): boolean {
        const conductorIndex = this.currentCasingPlan.wellSegments.findIndex(s => s.casingType.definition === CasingType.Conductor);
        return conductorIndex !== -1;
    }

    get hasShoe(): boolean {
        return this.wellSegment.casingShoeDepth !== undefined && this.wellSegment.casingShoeDepth !== null && this.wellSegment.casingShoeDepth > 0;
    }

    get hasStartAndEnd(): boolean {
        let result: boolean = false;
        if (this.wellSegment.gisObjects && this.wellSegment.gisObjects.length > 0) {
            const start = this.wellSegment.gisObjects.findIndex(g => g.point.toLowerCase() === "start");
            const end = this.wellSegment.gisObjects.findIndex(g => g.point.toLowerCase() === "end");
            result = start !== -1 && end !== -1;
        }
        return result;
    }

    get haveKickPoint(): boolean {
        let result: boolean = false;
        if (this.wellSegment && this.wellSegment.gisObjects) {
            const pointIndex = this.wellSegment.gisObjects.findIndex(g => g.point.toLowerCase() === "kick point");
            result = pointIndex !== -1;
        }
        return result;
    }

    get inAbandonedMineArea(): boolean {
        return this.rulesService.withinAbandonedMineArea;
    }

    get inActiveMineArea(): boolean {
        return this.rulesService.withinActiveMineArea;
    }

    get packerRequired(): boolean {
        return this.rulesService.packerRequired;
    }

    get segmentLength(): number {
        return this.wellSegment.casingBottom - this.wellSegment.casingTop;
    }

    get showEditWarning(): boolean {
        let result = false;
        switch (this.substep) {
            case SegmentWizardSteps.Casing:
                result = this.activeEditing && this.segmentIndex < this.currentCasingPlan.wellSegments.length - 1;
            break;
            case SegmentWizardSteps.Tools:
                if (this.activeEditing && this.wellSegment.casingType.definition === CasingType.Conductor) {
                    result = isDefined(this.wellSegment.formation.definition) || this.wellSegment.gisObjects.length > 1;
                }
            break;
            default:
                result = false;
            break;

        }
        return result;
    }

    public addGisDataToWellSegment(): void {
        const existingIndex = this.wellSegment.gisObjects.findIndex(g => g === this.newGisObject);
        if (existingIndex !== -1) {
            this.wellSegment.gisObjects.splice(existingIndex, 1);
        }
        this.wellSegment.gisObjects.push(this.newGisObject);
        const index = this.wellSegment.gisObjects.length - 1;
        this.newGisObject = new WellSegmentGisDataModel();
        this.newGisObject.point = "Kick Point";
        this.newGisObject.tvd = this.wellSegment.gisObjects[index].tvd;
        this.newGisObject.longitude = this.wellSegment.gisObjects[index].longitude;
        this.newGisObject.latitude = this.wellSegment.gisObjects[index].latitude;
        this.refreshGisGrid();
    }

    public addNewStringChanged(): void {
        if (this.addNewString === "") {
            this.queueSegment = undefined;
        } else {
            this.queueSegment = this.addNewString.toLowerCase() === "true";
        }
        this.segmentAdded.emit(this.queueSegment);
    }

    public buildForm(): void {
        this.editingWellSegment = deepClone(this.wellSegment);
        switch (this.substep) {
            case SegmentWizardSteps.Casing:
                this.formGroup = this.builder.group({
                    selectedCasing: [this.editingWellSegment.casingType.code, [requireNonDefaultOption(this.editingWellSegment, "casingType")]]
                });
            break;
            case SegmentWizardSteps.Conditions:
                this.formGroup = this.builder.group({
                    selectedCondition: [this.editingWellSegment.casingCondition.id, [requireNonDefaultOption(this.editingWellSegment, "condition")]],
                    reconditionAccept: [this.editingWellSegment.casingCondition.reconditionAccepted, [reconditioned(this.editingWellSegment, "accept")]],
                    reconditionAcknowledge: [this.editingWellSegment.casingCondition.reconditionAcknowledged, [reconditioned(this.editingWellSegment, "acknowledge")]]                    
                });
            break;
            case SegmentWizardSteps.Tools:
                this.formGroup = this.builder.group({
                    selectedTool: [this.editingWellSegment.drillingEquipment.code, [requireNonDefaultOption(this.editingWellSegment, "drillingEquipment")]] 
                });
            break;
            case SegmentWizardSteps.AngleBuilder:
                const start = this.wellSegment.gisObjects.find(p => p.point === "Start");
                this.newGisObject.latitude = start.latitude;
                this.newGisObject.longitude = start.longitude;
                this.newGisObject.tvd = start.tvd;
            break;
            default:
                this.formGroup = null;
            break;
        }
        if (this.activeEditing) {
            if (this.formGroup) {
                if (this.disableForm) {
                    this.formGroup.disable();
                } else {
                    this.formGroup.enable();
                }
            }
            this.formReady.emit(this.formGroup);
        }
    }


    public casingChanged(e: string): void {
        const selected = this.availableCasings.find(c => c.code === e);
        this.wellSegment.casingType = selected;
        this.rulesService.checkCompletionEligibility(selected.code);
        this.availableTools$ = this.getAvailableTools();
        this.rulesService.evaluateAlerts();
    }

    public conditionChanged(e: string): void {
        const selected = this.availableConditions.find(c => c.id === e);
        this.wellSegment.casingCondition = selected;
    }

    public defaultPointOption(text: string): boolean {
        return text.toLowerCase() === "kick point";
    }

    public deleteRow(obj: any): void {
        this.obj = obj;
        if (obj.point === "Start") {
            this.dialogService.openDialog("ok", "The 'Start' point of the string cannot be deleted.  You must change the length or 'End' of the previous string to update the 'Start' of this string.", "cannotDelete");
        } else {
            this.dialogService.openDialog("confirmCancel", `Are you sure you want to delete this point (${obj.point}, ${obj.tvd}' depth, ${obj.latitude}&#176; latitude, ${obj.longitude}&#176; longitude)?`, "verifyDelete");
        }
    }

    public dataChanged(idx: number): void { //index is that of the string whose data was changed.  All succeeding strings need to be deleted.
        this.deleteSegment(idx + 1);
    }

    public deleteSegment(idx: number): void {
        if (idx === undefined || idx === null) {
            idx = this.segmentIndex;
        }
        this.segmentDeleted.emit(idx);
    }

    public getAvailableCasings(): Observable<CasingTypeModel[]> {
        const lastCasing = (this.previousSegment) ? this.previousSegment.casingType.code : "";
        return this.rulesService.getAllowableStrings(lastCasing);
    }

    public getAvailableConditions(): Observable<CasingConditionModel[]> {
		return this.domainService.getValues("CasingCondition").pipe(
			map(
				conditions => {
					this.availableConditions = [];
					this.availableConditions.push(this.defaultCondition);
					for (let c = 0; c < conditions.length; c++) {
						var model = new CasingConditionModel();
						model.name = conditions[c].name;
						model.id = conditions[c].id;
						if (model.name.toLowerCase() === "reconditioned") {
							model.reconditionAccepted = false;
							model.reconditionAcknowledged = "No";
						}
						this.availableConditions.push(model);
					}
					return this.availableConditions;
				}
			)
        );
    }

    public getAvailableTools(): Observable<DrillingEquipmentModel[]> {
        const casingType = this.wellSegment.casingType.definition;
        return this.rulesService.getAllowableTools(casingType, this.currentCasingPlan.isUrbanizedArea);
    }

    public gisOnGridReady(params): void {
        this.gisGridApi = params.api;
        this.gisGridApi.sizeColumnsToFit();
        this.gisGridApi.refreshCells();
    }

    public onFormReady(form: FormGroup): void {
        this.formReady.emit(form);
    }

    public parseSegmentData(): void {
        this.segmentData = [];
        this.segmentData.push({
            casingType: this.wellSegment.casingType.definition,
            casingCondition: this.wellSegment.casingCondition.name,
            drillingEquipment: this.wellSegment.drillingEquipment.definition,
            diameter: this.wellSegment.casingDiameter,
            length: this.wellSegment.casingLength,
            cementVolume: this.wellSegment.cementVolume
        });
        if (this.segmentGridApi) {
            this.segmentGridApi.setGridOption("rowData", this.segmentData);
        }
    }

    public refreshGisGrid(): void {
        if (this.gisGridApi) {
            this.gisGridApi.setGridOption("rowData", this.wellSegment.gisObjects);
        }
    }

    public resetSegmentPoints(segment): void {
        const start = segment.gisObjects.find(g => g.point === "Start");
        segment.gisObjects = [];
        segment.gisObjects.push(start);
    }

    public resetSegmentSizeAndDepth(segment): void {
        segment.formation = new FormationModel();
        segment.casingAndCementSource = undefined;
        segment.boreholeDiameter = undefined;
        segment.boreholeDepth = undefined;
        segment.boreholeTop = (this.previousSegment) ? this.previousSegment.boreholeBottom : 0;
        segment.boreholeBottom = undefined;
        segment.casingDiameter = undefined;
        segment.casingTop = !this.previousSegment ? 0 : undefined;
        segment.casingBottom = undefined;
        segment.casingLength = undefined;
        segment.casingGrade = undefined;
        segment.casingWeight = undefined;
        segment.casingShoeDepth = undefined;
        segment.numberCentralizers = undefined;
        segment.floatCollarDepth = undefined;
        segment.basketDepth = undefined;
        segment.packerDepth = undefined;
        segment.dvToolDepth = undefined;
        segment.cementVolume = undefined;
        segment.cementTop = undefined;
        segment.cementBottom = undefined;
        segment.perforationTop = undefined;
        segment.perforationBottom = undefined;
        segment.stageNumber = undefined;
        segment.numberOfStages = undefined;
        segment.shotsPerStage = undefined;
        segment.zoneTestedOrProduced = undefined;
        segment.hydraulicFracturing = undefined;
        segment.toBePulled = undefined;
        segment.hasAngles = undefined;
    }

    public resetWellSegment(segment: WellSegmentModel): void { //resetting values instead of simply doing "new" because making a new instance somehow breaks the chain to the other components and alerts
        segment.casingType = new CasingTypeModel();
        segment.casingCondition = new CasingConditionModel();
        segment.drillingEquipment = new DrillingEquipmentModel();
        this.resetSegmentSizeAndDepth(segment);
        this.resetSegmentPoints(segment);
    }

    public segmentGridOnReady(params): void {
        this.segmentGridApi = params.api;
        this.segmentGridApi.sizeColumnsToFit();
        this.segmentGridApi.refreshCells();
    }

    public setActive(): void {
        this.makeSegmentActive.emit(this.wellSegment);
    }

    public sortHigher(obj): void {
        if (this.wellSegment.gisObjects.length <= 2) return;
        const index = this.wellSegment.gisObjects.findIndex(gObj => gObj === obj);
        if (index === 0) return;
        const objArray = [];
        for (let g = 0; g < this.wellSegment.gisObjects.length; g++) {
            const distance = index - g;
            let gisObj: any;
            if (distance === 1) {
                gisObj = this.wellSegment.gisObjects[g + 1];
            } else if (distance === 0) {
                gisObj = this.wellSegment.gisObjects[g - 1];
            } else {
                gisObj = this.wellSegment.gisObjects[g];
            }
            if (isDefined(gisObj)) {
                objArray.push(gisObj);
            }
        }
        this.wellSegment.gisObjects = objArray;
    }

    public sortLower(obj): void {
        if (this.wellSegment.gisObjects.length <= 2) return;
        const index = this.wellSegment.gisObjects.findIndex(gObj => gObj === obj);
        if (index === this.wellSegment.gisObjects.length - 1) return;
        const objArray = [];
        for (let g = 0; g < this.wellSegment.gisObjects.length; g++) {
            const distance = index - g;
            let gisObj: any;
            if (distance === -1) {
                gisObj = this.wellSegment.gisObjects[g - 1];
            } else if (distance === 0) {
                gisObj = this.wellSegment.gisObjects[g + 1];
            } else {
                gisObj = this.wellSegment.gisObjects[g];
            }
            if (isDefined(gisObj)) {
                objArray.push(gisObj);
            }
        }
        this.wellSegment.gisObjects = objArray;
    }

    public startEndDisabled(selectText: string): boolean {
        if (selectText.toLowerCase() !== "start" && selectText.toLowerCase() !== "end") return false;
        return this.wellSegment.gisObjects.findIndex(gis => gis.point.toLowerCase() === selectText.toLowerCase()) !== -1;
    }

    public toggleContent(contentType: string): void {
        let now: boolean;
        switch (contentType) {
            case "casingDefinition":
                now = this.showCasingDefinition;
                this.showCasingDefinition = !now;
            break;
            case "reconditionedInfo":
                now = this.showReconditionedInfo;
                this.showReconditionedInfo = !now;
            break;
            case "segmentRules":
                now = this.showSegmentRules;
                this.showSegmentRules = !now;
            break;
        }
    }

    public toolChanged(e: string): void {
        const selected = this.availableTools.find(t => t.code === e);
        this.wellSegment.drillingEquipment = selected;
    }

    public updateWellSegment(segment: WellSegmentModel, updateAlerts: boolean): void {
        if (this.formGroup.controls["selectedCasing"]) {
            const casingType = this.formGroup.controls["selectedCasing"].value;
            const selected = this.availableCasings.find(c => c.code === casingType);
            segment.casingType = selected;
            if (segment.casingType.definition === CasingType.Tubing) {
                segment.casingTop = 0;
                segment.boreholeTop = null;
            }
            if (updateAlerts) {
                this.segmentChanged.emit(segment);
                this.rulesService.checkCompletionEligibility(selected.code);
                this.availableTools$ = this.getAvailableTools();
                this.rulesService.evaluateAlerts();
            }
        }
        if (this.formGroup.controls["selectedCondition"]) {
            const condition = this.formGroup.controls["selectedCondition"].value;
            const selected = this.availableConditions.find(c => c.id === condition);
            segment.casingCondition = selected;
            if (segment.casingCondition.name.toLocaleLowerCase() === "reconditioned") {
                const accept = this.formGroup.controls["reconditionAccept"].value;
                const acknowledge = this.formGroup.controls["reconditionAcknowledge"].value;
                segment.casingCondition.reconditionAccepted = accept;
                segment.casingCondition.reconditionAcknowledged = acknowledge;
            } else {
                this.formGroup.controls["reconditionAccept"].patchValue(null);
                this.formGroup.controls["reconditionAcknowledge"].patchValue(null);
                segment.casingCondition.reconditionAccepted = undefined;
                segment.casingCondition.reconditionAcknowledged = undefined;
            }
        }
        if (this.formGroup.controls["selectedTool"]) {
            const tool = this.formGroup.controls["selectedTool"].value;
            const selected = this.availableTools.find(t => t.code === tool);
            segment.drillingEquipment = selected;
            if (updateAlerts) {
                this.segmentChanged.emit(segment);
                this.availableTools$ = this.getAvailableTools();
                this.rulesService.evaluateAlerts();
            }
        }
        this.parseSegmentData();
    }

    public validateForm(): void {
        this.updateWellSegment(this.editingWellSegment, false);
        let valueChanged = "";
        //these ifs are mutually exclusive
        if (this.formGroup.controls["selectedCasing"]) {
            this.formGroup.controls["selectedCasing"].updateValueAndValidity();
            valueChanged = "CasingType";
        } else if (this.formGroup.controls["selectedCondition"]) {
            this.formGroup.controls["selectedCondition"].updateValueAndValidity();
            this.formGroup.controls["reconditionAccept"].updateValueAndValidity();
            this.formGroup.controls["reconditionAcknowledge"].updateValueAndValidity();
            valueChanged = "CasingCondition";
        } else if (this.formGroup.controls["selectedTool"]) {
            this.formGroup.controls["selectedTool"].updateValueAndValidity();
            valueChanged = "DrillingEquipment";
        }

        if (this.formGroup.valid) {
            switch (valueChanged) {
            case "CasingType":
                if (this.segmentIndex !== this.currentCasingPlan.wellSegments.length - 1) {
                    this.deleteSegment(this.segmentIndex + 1);
                    this.resetWellSegment(this.wellSegment);
                    this.updateWellSegment(this.wellSegment, true);
                } else {
                if (this.editingWellSegment.casingType.definition !== this.wellSegment.casingType.definition && isDefined(this.wellSegment.casingType.definition)) { //reset the object in case we've gone past casing type before
                    this.resetWellSegment(this.wellSegment);
                }
                this.updateWellSegment(this.wellSegment, true);
                }
                break;
            case "DrillingEquipment":
                if (this.wellSegment.casingType.definition === CasingType.Conductor) {
                if (this.editingWellSegment.drillingEquipment.definition && this.wellSegment.drillingEquipment.definition) {
                    if (this.editingWellSegment.drillingEquipment.definition.toLowerCase() === "concentric" || this.wellSegment.drillingEquipment.definition.toLowerCase() === "concentric") {
                        this.deleteSegment(this.segmentIndex + 1);
                        this.resetSegmentSizeAndDepth(this.wellSegment);
                        this.resetSegmentPoints(this.wellSegment);
                        this.updateWellSegment(this.wellSegment, true);
                    } else {
                        this.updateWellSegment(this.wellSegment, true);
                    }
                } else {
                    this.updateWellSegment(this.wellSegment, true);
                }

                } else {
                    this.updateWellSegment(this.wellSegment, true);
                }
                break;
            default: //change doesn't cause any resetting, just update
                this.updateWellSegment(this.wellSegment, true);
                break;
            }
        }
    }

    public whatDetail(): string {
        if (this.haveKickPoint) {
            if (this.wellDirection == "Other Horizontal") {
                return "Horizontal";
            } else {
                return this.wellDirection;
            }
        } else {
            return "Vertical";
        }
    }

    public onDialogConfirm(): void {
        this.dialogService.closeDialog();
        if (this.dialogService.dialogId === 'verifyDelete') {
            const objIndex = this.wellSegment.gisObjects.findIndex(g => g === this.obj);
            this.wellSegment.gisObjects.splice(objIndex, 1);
            if (this.gisGridApi) {
            this.gisGridApi.setGridOption("rowData", this.wellSegment.gisObjects);
            }
        } else if (this.dialogService.dialogId === 'cannotDelete') {
            //Do nothing
        }
    }

    public onDialogClose(): void {
        this.dialogService.closeDialog();
        console.log('delete cancelled');
    }

}
